import { getLanguage } from "./init";

export type Lang = "en" | "ru" | "pl" | "ua";

let _langs: Lang[];
let _currentLang: number;

export function setTranslations(langs: Lang[], currentLang?: Lang): void {
    _langs = langs;
    _currentLang = langs.indexOf(currentLang ?? getLanguage());
}

const missings = new Set<string>();

export default function t(...strs: string[]): string {
    let res = strs[_currentLang];
    if (res === undefined) {
        res = strs[0];
        if (!missings.has(res)) {
            missings.add(res);
            // eslint-disable-next-line no-console
            console.warn(`Missing ${_langs[_currentLang]} translation: ${strs[0]}`);
        }
    }
    return res;
}
